import { EmbroideryTypeKey } from '../combination-rules/types'

import { ExternalEmbroideryFormKind } from './facade'

import type { ProductCatalogEmbroideryTypes } from '../../../__generated__/graphql/catalog/graphql'

// TODO: There's too many of these that look almost identical, let's see if we can consolidate these
// or find a way to agree on casing so they aren't needed

/**
 * The engine names embroidery types in lower case and the catalog names them in upper case, so
 * anything that crosses between them translates here. Exhaustive, so a new embroidery type does
 * not compile until its catalog name is given.
 */
export const CATALOG_TYPE_BY_TYPE_KEY: Record<EmbroideryTypeKey, ProductCatalogEmbroideryTypes> = {
  text: 'TEXT',
  icon: 'ICON',
  logo: 'LOGO',
}

export const TYPE_KEY_BY_CATALOG_TYPE: Record<ProductCatalogEmbroideryTypes, EmbroideryTypeKey> = {
  TEXT: 'text',
  ICON: 'icon',
  LOGO: 'logo',
}

/** The old summary card names a DTC logo `LOGO_DTC`; the new stack only knows it as a logo. */
export const FORM_KIND_BY_TYPE_KEY: Record<EmbroideryTypeKey, ExternalEmbroideryFormKind> = {
  text: 'TEXT',
  icon: 'ICON',
  logo: 'LOGO_DTC',
}

export const TYPE_KEY_BY_FORM_KIND: Record<ExternalEmbroideryFormKind, EmbroideryTypeKey> = {
  TEXT: 'text',
  ICON: 'icon',
  LOGO_DTC: 'logo',
  LOGO_SETUP: 'logo',
  LOGO_B2B: 'logo',
}

export const toCatalogTypes = (
  typeKeys: readonly EmbroideryTypeKey[]
): ProductCatalogEmbroideryTypes[] => typeKeys.map(typeKey => CATALOG_TYPE_BY_TYPE_KEY[typeKey])

export const toTypeKeys = (
  catalogTypes: readonly ProductCatalogEmbroideryTypes[]
): EmbroideryTypeKey[] => catalogTypes.map(catalogType => TYPE_KEY_BY_CATALOG_TYPE[catalogType])
